import React from 'react';
import { database } from '../data/database.ts';

const Hero: React.FC = () => {

  const db = database.hero;

  return (
    <section id="hero" className="hero section dark-background">
      <div id="heroCarousel" className="carousel slide" data-bs-ride="carousel">
        <ol className="carousel-indicators">
          {
            db.sliders.map((slider, index) => (
              <li key={index} data-bs-target="#heroCarousel" data-bs-slide-to={index} className={index === 0 ? 'active' : ''}></li>
            ))
          }
        </ol>

        <div className="carousel-inner">
          {
            db.sliders.map((slider, index) => (
              <div key={index} className={index === 0 ? 'carousel-item active' : 'carousel-item'} style={{'backgroundImage': `url(${slider.backgroundImage})`, 'backgroundSize': 'cover'}}>
                <div className="overlay"/>
                <div className="container">
                  <div className="row gy-4 justify-content-between">
                    <div className="col-lg-4 order-lg-last hero-img" data-aos="zoom-out" data-aos-delay="500">
                      <img src={slider.image} className="img-fluid animated" alt="Hero 1" />
                    </div>
                    <div className="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-in">
                      <h1>{slider.title}</h1>
                      <p>{slider.description}</p>
                      <div className="d-flex">
                        <a href={slider.buttonLink} className="btn-get-started">Ver más</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          }
        </div>

        <a className="carousel-control-prev" href="#heroCarousel" role="button" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Anterior</span>
        </a>
        <a className="carousel-control-next" href="#heroCarousel" role="button" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Siguiente</span>
        </a>
      </div>
    </section>
  );
};

export default Hero;
